import { ModalTitle } from "@kaltura/ds-react-components";
import { KmsTypeComponent, PreCreationToolProps } from "@kaltura/mediaspace-shared-types";
import { CustomComponent } from "../custom-component/CustomComponent";

export interface PreCreationToolViewProps {
    /**
     * Modal title to display above the pre-creation tool
     */
    title: string;
    /**
     * Pre-creation tool component definition (e.g. Disclaimer)
     */
    preCreationToolComponent: KmsTypeComponent<any, PreCreationToolProps>;
    /**
     * Callback when user clicks Back or declines
     */
    onBack?: () => void;
    /**
     * Callback when user accepts / submits pre-creation tool
     */
    onSubmit: () => void;
}

/**
 * PreCreationToolView renders a pre-creation tool (e.g., disclaimer) inside a modal dialog.
 */
export const PreCreationToolView = ({
    title,
    preCreationToolComponent,
    onBack,
    onSubmit,
}: PreCreationToolViewProps) => {
    return (
        <>
            <ModalTitle>{title}</ModalTitle>
            <CustomComponent component={preCreationToolComponent} onBack={onBack} onSubmit={onSubmit} />
        </>
    );
};

export default PreCreationToolView;
